/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Button,
  HeadingBanner,
  Link,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import SavedAddressCard from './SavedAddressCard';
import AddressHiddenFields from './AddressHiddenFields';

export default function SavedAddress({
  textFor, setModalVisibility, showSavedAddress,
  updateAddress, isSavedAddress,
}) {
  const onChange = () => {
    setModalVisibility(true);
  };

  const onSavedAddressClick = () => {
    setModalVisibility(true);
  };
  if (!showSavedAddress && !isSavedAddress) {
    return (
      <section className="shipping-info-without-address" data-testid="saved-address--without-address-data">
        <h2 data-property={textFor.shippingAddress.key}>
          {textFor.shippingAddress?.value}
        </h2>
      </section>
    );
  }
  if (!showSavedAddress) {
    return (
      <section className="shipping-info-without-address" data-testid="saved-address--without-address">
        <HeadingBanner variant="boxed">
          <h2 data-property={textFor.shippingAddress.key}>
            {textFor.shippingAddress?.value}
          </h2>
          <Link
            onClick={onSavedAddressClick}
            labelText={textFor?.savedAddress?.value}
          >
            {textFor?.savedAddress?.value}
          </Link>
        </HeadingBanner>
      </section>
    );
  }
  return (
    <section className="saved-address-info" data-testid="saved-address">
      <HeadingBanner variant="boxed">
        <h2 data-property={textFor.shippingAddress.key}>
          {textFor.shippingAddress?.value}
        </h2>
      </HeadingBanner>
      {updateAddress && showSavedAddress && (
      <dl>
        <dt>
          <SavedAddressCard address={updateAddress} isCountryFlagVisible={false} />
          <AddressHiddenFields address={updateAddress} />
        </dt>
        <dd>

          <Button
            onClick={onChange}
            variant="borderless"
            classList="linkButton"
            labelText={textFor?.change?.value}
          >
            {textFor?.change?.value}
          </Button>
        </dd>
      </dl>
      )}
    </section>
  );
}

SavedAddress.propTypes = {
  updateAddress: PropTypes.shape({
    address1: PropTypes.string, // define shippingAddress address1
    address2: PropTypes.string, // define shippingAddress address2
    city: PropTypes.string, // define shippingAddress city
    state: PropTypes.string, // define shippingAddress state
    postalCode: PropTypes.string, // define shippingAddress postal code
    sameDayStoreId: PropTypes.string, // define shippingAddress sameDayStoreId
    addressId: PropTypes.string, // define shippingAddress addressId
    country: PropTypes.string, // define shippingAddress country
    isAddressVerified: PropTypes.bool, // define shippingAddress isAddressVerified for Loqate
    email: PropTypes.string, // define shippingAddress email
    isBillingAllowed: PropTypes.bool, // define shippingAddress isBillingAllowed
    isDefaultBilling: PropTypes.bool, // define shippingAddress isDefaultBilling
    isDefaultShipping: PropTypes.bool, // define shippingAddress isDefaultShipping
    isShippingAllowed: PropTypes.bool, // define shippingAddress isShippingAllowed
    firstName: PropTypes.string, // define shippingAddress firstName
    lastName: PropTypes.string, // define shippingAddress lastName
    orgName: PropTypes.string, // define shippingAddress orgName
    pickUpStoreId: PropTypes.string, // define shippingAddress pickupStoreId
    poBox: PropTypes.bool, // define shippingAddress poBox
    title: PropTypes.string, // define shippingAddress title
    zone: PropTypes.string, // define shippingAddress zone
    district: PropTypes.string, // define shippingAddress district
    prefecture: PropTypes.string, // define shippingAddress prefecture
  }),
  textFor: PropTypes.shape({
    shippingAddress: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    change: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    savedAddress: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  }),
  setModalVisibility: PropTypes.func,
  showSavedAddress: PropTypes.bool,
  isSavedAddress: PropTypes.bool,

};

SavedAddress.defaultProps = {
  updateAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    firstName: '',
    lastName: '',
    sameDayStoreId: '',
    country: '',
    isAddressVerified: false,
    email: '',
    isBillingAllowed: false,
    isDefaultBilling: false,
    isDefaultShipping: false,
    isShippingAllowed: false,
    orgName: '',
    pickUpStoreId: '',
    poBox: false,
    title: '',
    zone: '',
    district: '',
    prefecture: '',
  },
  textFor: {
    shippingAddress: {
      key: '',
      value: '',
    },
    change: {
      key: '',
      value: '',
    },
    savedAddress: {
      key: '',
      value: '',
    },
  },
  setModalVisibility: () => {},
  showSavedAddress: false,
  isSavedAddress: false,
};
